/* global angular */

angular.module('currencyInputFormatterCmp', [])
  .directive('currencyInputFormatter', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attrs, modelCtrl) {
        modelCtrl.$formatters.push(groupBy3)
        return modelCtrl.$parsers.push(function (input) {
          if (!input) {
            if (scope.vm.allowEmpty === 'true') {
              return input
            }
          }

          // remove all-nondigits
          var value = input.toString().replace(/\D/g, '')

          // set default value if value is empty
          if (value === '') {
            value = scope.vm.defaultValue
          }

          // remove all leading zeros
          if (value) {
            value = Number(value).toString()
          }

          if (Number(input.toString().replace(/\s/g, '')) !== Number(value) && typeof scope.vm.resetCallbackFn === 'function') {
            scope.vm.resetCallbackFn()
          }

          if (!value) {
            value = scope.vm.ngMin
          }

          // set min value
          if (value && scope.vm.ngMin) {
            if (parseFloat(value) < parseFloat(scope.vm.ngMin)) {
              value = scope.vm.ngMin.toString()
            }
          }

          // set max value
          if (value && scope.vm.ngMax) {
            if (parseFloat(value) > parseFloat(scope.vm.ngMax)) {
              value = scope.vm.ngMax.toString()
            }
          }

          // set to view and model
          modelCtrl.$setViewValue(groupBy3(value))
          modelCtrl.$render()
          return parseFloat(value)
        })
      }
    }

    function groupBy3 (input) {
      return input ? input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : input
    }
  })
